import {getTracerModules, ITracerErrorData} from '@tracer/sdk';
import {
  isChunkError,
  isPendingRecoveryFromChunkError,
  tryRecoverFromChunkError,
} from '@utils/tracer/chunkError';
import {useEffect} from 'react';

export const useReportErrorFromBoundary = (error: Error) => {
  useEffect(() => {
    if (
      (isChunkError(error) && tryRecoverFromChunkError()) ||
      isPendingRecoveryFromChunkError()
    ) {
      return;
    }
    getTracerModules().error?.error(error, {
      keys: {fromErrorBoundary: true},
      type: 'CRASH',
    } as unknown as ITracerErrorData);
  }, [error]);
};
